import { configureStore, EnhancedStore } from '@reduxjs/toolkit'
import rootReducers from '../reducers/rootReducers';

let store: EnhancedStore;
const configureAppStore = (): EnhancedStore => {
    store = configureStore({
        reducer: rootReducers,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
        devTools: true
    });
    return store;
};

export default configureAppStore;
